import axios from 'axios';

const cdnApi = axios.create({
	baseURL: `//${process.env.VUE_APP_CDN_HOST}`,
});

export default cdnApi;
